import React from 'react';
import { SwiperSlide } from "swiper/react/swiper-slide"

import "swiper/swiper.min.css";
import "swiper/modules/navigation/navigation.min.css";
import "swiper/modules/pagination/pagination.min.css";

const TestimonialItem = ({value: {image,msg}}) => {
    
    return (
        <SwiperSlide>
            <div className="testimonial__content">
                <div className="testimonial__data">
                    <div className='testimonial__header'>
                        <img src={image} className="testimonial__image" alt="shafnas-testimonial" />
                        <div>
                            <h3 className='testimonial__name'>Client</h3>
                        </div>
                    </div>
                    <div>
                        <i className='uil uil-star testimonial__icon-star'></i>
                        <i className='uil uil-star testimonial__icon-star'></i>
                        <i className='uil uil-star testimonial__icon-star'></i>
                        <i className='uil uil-star testimonial__icon-star'></i>
                        <i className='uil uil-star testimonial__icon-star'></i>
                    </div>
                </div>
                <p className='testimonial__description'>{msg}</p>
            </div>
        </SwiperSlide>
    )
}

export default TestimonialItem;